import React, { ChangeEvent, useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Tooltip,
} from '@mui/material'
import { useNavigateTo } from 'infrastructure/routing'
import {
  deleteDistrict,
  deleteSchool,
  deleteManyUsers,
  deleteManyDemos,
} from 'shared/api/mutations'

const DeleteResourceButton = ({
  name,
  resource,
  schoolID,
  districtID,
  userID,
  demoID,
}: {
  name: string
  resource: string
  schoolID?: number
  districtID?: number
  userID?: number
  demoID?: number
}) => {
  const [open, setOpen] = useState(false)
  const [deleteUsers, setDeleteUsers] = useState(true)
  const [deleteSchools, setDeleteSchools] = useState(true)
  const navigate = useNavigateTo()
  const redirect = () => {
    if ((districtID && schoolID) || districtID) {
      navigate(`/districts/${districtID}/show`)
    } else if (schoolID) {
      navigate(`/schools/${schoolID}/show`)
    } else if (userID) {
      navigate(`/users/${userID}/show`)
    } else if (demoID) {
      navigate('/demos')
    }
  }

  const doDelete = async () => {
    if (schoolID) {
      await deleteSchool([schoolID], deleteUsers)
    } else if (districtID) {
      await deleteDistrict([districtID], deleteSchools, deleteUsers)
    } else if (userID) {
      await deleteManyUsers([userID])
    } else if (demoID) {
      await deleteManyDemos([demoID])
    }
    redirect()
  }
  const title = 'Are you sure you want to delete this ' + resource + '?'
  const buttonText = 'Delete ' + resource

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const onDeleteSchoolsChange = (event: ChangeEvent<HTMLInputElement>) => {
    setDeleteSchools(event.target.checked)
  }

  const onDeleteUsersChange = (event: ChangeEvent<HTMLInputElement>) => {
    setDeleteUsers(event.target.checked)
  }

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        {buttonText}
      </Button>
      <Dialog onClose={handleClose} open={open} data-testid="dialog">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <span>
              {resource} Name: {name}
            </span>
          </DialogContentText>
          <Box>
            {districtID && (
              <Tooltip
                title="Select this option to soft-delete schools"
                placement="right-start"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={deleteSchools}
                      onChange={onDeleteSchoolsChange}
                      name="deleteSchools"
                    />
                  }
                  label="Delete Schools"
                />
              </Tooltip>
            )}
            {(districtID || schoolID) && (
              <Tooltip
                title="Select this option to soft-delete users"
                placement="right-start"
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={deleteUsers}
                      onChange={onDeleteUsersChange}
                      name="deleteUsers"
                    />
                  }
                  label="Delete Users"
                />
              </Tooltip>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={doDelete}>Yes</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DeleteResourceButton
